var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53599 5.74981C7.53599 6.73601 6.7365 7.53551 5.7503 7.53551C4.76409 7.53551 3.9646 6.73601 3.9646 5.74981C3.9646 4.7636 4.76409 3.96411 5.7503 3.96411C6.7365 3.96411 7.53599 4.7636 7.53599 5.74981Z",
    stroke: "#8790A1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64845 11.8168C6.40753 12.0487 6.08553 12.1785 5.75046 12.1785C5.41532 12.1785 5.09332 12.0487 4.8524 11.8168C2.64628 9.67906 -0.310202 7.29101 1.13158 3.82406C1.91114 1.9495 3.78244 0.75 5.75046 0.75C7.71844 0.75 9.58971 1.94951 10.3693 3.82406C11.8093 7.28665 8.86 9.68641 6.64845 11.8168Z",
    stroke: "#8790A1",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0359 13.6069C10.0359 14.3959 8.11718 15.0355 5.75027 15.0355C3.38336 15.0355 1.4646 14.3959 1.4646 13.6069",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIc);
export default __webpack_public_path__ + "static/media/address_ic.8aeb88f2d9ffe635ea9ac895efb83806.svg";
export { ForwardRef as ReactComponent };